import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { Form } from 'antd';
import PropTypes from "prop-types";
import { InputField } from "../../../../../../../CommonComponents/commonStyles";
import formatter from "../../../../../../../utils/formatter";
import { WrapLabel, LabelWrapper, InputWrapper } from './styles';
import { changeAccountNumber,checkVGMutualFund,updateContributionStatus,updateErrorMessage } from "../../../actions";
import { Rules } from "../Rules/Rules";
import TooltipComponent from "../../../../../../../CommonComponents/Info/Tooltip/TooltipComponent";
let isEdit = false;
let data = "";

export class VanguardAccountNumber extends React.Component {
    constructor(props) {
        super(props);
        this.state = {value: false, currentValue: this.props.value};
    }
   
    componentWillReceiveProps (nextProps){
        if(this.props.assetHeld === nextProps.showErrorMessage.assetHeld && nextProps.showErrorMessage.accountNo){
            let id = this.props.accountId.toString() + this.props.assetHeld + this.props.property;
            let value = {};
            value[id] =  this.props.value;
            this.props.form.setFieldsValue(value);
          this.props.form.validateFields();
          if((this.props.accountId) === this.props.giftLength){
            if(!(['assetHeldatVG','assetOutsideVG'].includes(this.props.assetHeld) && this.props.contributionType === 'mutualFund' && this.props.isSecuritySelected))
            this.props.updateErrorMessages({type: 'accountNo'});
          }
          if((this.props.accountId) === this.props.giftLength && this.props.accountSelected === 'Select Account Type' && this.props.property === 'amount'){
            if(!(['assetHeldatVG','assetOutsideVG'].includes(this.props.assetHeld) && this.props.contributionType === 'mutualFund' && this.props.isSecuritySelected) || ['checkOrEBT','wire','stockCertificate'].includes(this.props.assetHeld)){
            this.props.updateErrorMessages({type: 'dropDown'});
            this.props.updateErrorMessages({type: 'inputDropDown'});
            this.props.updateErrorMessages({type: 'addressInput'});
            this.props.updateErrorMessages({type: 'inputComponent'});
            }
          }
        } else if(nextProps.isCleared !== this.props.isCleared && nextProps.isCleared){
            let id = this.props.accountId.toString() + this.props.assetHeld + this.props.property;
            let value = {};
            value[id] =  '11';
            this.props.form.setFieldsValue(value);
            this.props.form.validateFields();
            //bugfix - 6212 : updating cleared value in local state 
            this.setState({currentValue: nextProps.value})
        } 
        if(nextProps.value !== this.props.value && !(nextProps.isCleared !== this.props.isCleared && nextProps.isCleared)){
            this.setState({currentValue: nextProps.value})
        }
     }
     
    onFocusOut= (e) =>{
        let id = this.props.accountId.toString() + this.props.assetHeld + this.props.property;
        let value = {};
        value[id] =  e.target.value;
        this.props.form.setFieldsValue(value);
        this.props.form.validateFields();
        if(this.props.property === "amount"){
            isEdit = false;
            let value = e.target.value.replace(/[^0-9.]/g, ''); 
            value = formatter({
                value: e.target.value,
                fieldSuffix: 'Dollars',
            });   
            (this.props.value !== value) && this.props.updateValue(value);
            this.props.checkVGFund();
            if(this.props.contribTypeStatus === null) this.props.updateContributionStatus();
        }else{
            (this.props.value !== e.target.value) && this.props.updateValue(e.target.value);
        }
       
    }

    onFocus = () => {
        isEdit = true;
        this.setState({value: true});
    }

    onTextChange= (e,regex) => {
        let updatedValue = e.target.value.replace(/\s{2,}/g, ' ').replace('. ','');
        if(updatedValue.length === 1){
            updatedValue = updatedValue.replace(/\s{1,}/g, '');
          }
        if(regex.test(updatedValue)){
            if(this.props.contribTypeStatus === null) this.props.updateContributionStatus();
            if(this.props.property === "amount"){
                isEdit = true;
                let value = updatedValue.replace(/[^0-9.$]/g, '');
                if(value <= 999999999.99){
                (this.state.currentValue !== value) && this.setState({currentValue: value});
                }
            }else{   
                (this.state.currentValue !== updatedValue) && this.setState({currentValue: updatedValue});
            }   
        }
        if(this.props.property==="amount"){
            this.props.checkVGFund();
        }
    }

    clearAccountNumber = (e) => {
            this.props.updateValue("");
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        if(this.props.property === "amount" && isEdit){
            data = (this.state.currentValue.replace(/[^0-9.]/, "")).replace(/,/g, '').replace(".00",'');
        }else{
            data = this.state.currentValue;
        }
        let placeHolder = "Enter " + this.props.label.toLowerCase();
        return (
            <>
                <WrapLabel>
                    <InputWrapper>
                        <Form.Item
                            colon={false}
        label={<LabelWrapper>{this.props.label}{this.props.property==="VGAccountNumber"?<TooltipComponent text="If the assets are held in a brokerage account, enter the 8 digit account number. If the assets are held in a mutual fund account, enter only the account number."/>:null}</LabelWrapper>}>
                            {getFieldDecorator(this.props.accountId.toString() + this.props.assetHeld + this.props.property, {
                                validateTrigger: "onBlur",
                                rules: ((Rules[this.props.property] ? Rules[this.props.property].rules : "")),
                             })(
                                <InputWrapper>
                                    <InputField id={this.props.id} className="macInputFieldPadding" placeholder={placeHolder} aria-labelledby={this.props.property} role="textbox" value={data} onFocus = {e => this.onFocus(e) } onBlur={e => this.onFocusOut(e)}  onChange={e =>this.onTextChange(e,Rules[this.props.property]?Rules[this.props.property].onchangePattern:/^.*$/)} />
                                </InputWrapper>
                            )}
                        </Form.Item>
                    </InputWrapper>
                </WrapLabel>
        </>
        )
    }

}

const WrappedVanguardAccountNumber = Form.create({ name: "select" })(VanguardAccountNumber);

WrappedVanguardAccountNumber.propTypes = {
    value: PropTypes.String,
    isCleared: PropTypes.bool,
    contribTypeStatus: PropTypes.bool,
    showErrorMessage: PropTypes.object,
    isSecuritySelected: PropTypes.bool,
    accountSelected: PropTypes.string,


    updateValue: PropTypes.func,
    checkVGFund: PropTypes.func,
    updateContributionStatus: PropTypes.func,
    updateErrorMessages: PropTypes.func,

}

const mapStateToProps = (state, ownProps) => {
    return {
    value: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,`${ownProps.contributionType}`, `${ownProps.accountId}`,`${ownProps.property}`]),
    isCleared: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,'isCleared']),
    contribTypeStatus: state.getIn(['makeAContribution','contributionStatus', 'data', `${ownProps.assetHeld}`]),
    showErrorMessage: state.getIn(["makeAContribution","contributionTypes",'showErrorMessage']),
    isSecuritySelected: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,'sgSelected']),
    accountSelected: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,`${ownProps.contributionType}`, `${ownProps.accountId}`,'type']),
}};

export const mapDispatchToProps = (dispatch,ownProps) => {
    return {
    updateValue: e => dispatch(changeAccountNumber({value:e, accountId: ownProps.accountId, contributionType: ownProps.contributionType, assetHeld: ownProps.assetHeld, property: ownProps.property })),
    checkVGFund: e => dispatch(checkVGMutualFund({value: true,property: ownProps.selected, assetHeld: ownProps.assetHeld})),
    updateContributionStatus: () => dispatch(updateContributionStatus({value:false,assetHeld: ownProps.assetHeld})),
    updateErrorMessages: data => dispatch(updateErrorMessage(data))
}};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedVanguardAccountNumber));
